import { Link } from 'react-router-dom';

interface ArticleHeroProps {
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  tags: string[];
  publishedAt: string;
  views: number;
  author: { name: string; avatar: string };
}

const categorySlugMap: Record<string, string> = {
  '明星八卦': 'star-gossip',
  '综艺热点': 'variety-show',
  '影视追踪': 'film-tv',
  '社会热点': 'society',
  '音乐圈': 'music-circle',
};

export default function ArticleHero({
  title,
  excerpt,
  coverImage,
  category,
  tags,
  publishedAt,
  views,
  author,
}: ArticleHeroProps) {
  return (
    <section className="relative min-h-[380px] md:min-h-[480px] flex items-end overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-accent-100/20 to-secondary-100/30"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-8 md:pb-12">
        <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-12">
          <div className="lg:w-[60%] space-y-4">
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/category/${categorySlugMap[category] || 'star-gossip'}`}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/80 text-accent-600 text-xs font-semibold whitespace-nowrap hover:bg-accent-100/60 transition-colors"
              >
                <i className="ri-price-tag-3-line text-sm w-4 h-4 flex items-center justify-center"></i>
                {category}
              </Link>
              {tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/tag/${tag}`}
                  className="text-xs text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap"
                >
                  #{tag}
                </Link>
              ))}
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-900 leading-tight tracking-tight">
              {title}
            </h1>
          </div>

          <div className="lg:w-[40%] space-y-4">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              {excerpt}
            </p>
            <div className="flex items-center gap-4 text-sm text-foreground-500">
              <div className="flex items-center gap-2">
                <img
                  src={author.avatar}
                  alt={author.name}
                  className="w-7 h-7 rounded-full object-cover"
                />
                <span className="font-medium text-foreground-700 whitespace-nowrap">{author.name}</span>
              </div>
              <span className="text-foreground-300">|</span>
              <span className="whitespace-nowrap">{publishedAt}</span>
              <span className="text-foreground-300">|</span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-eye-line"></i> {(views / 10000).toFixed(1)}万阅读
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-10">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-44 md:h-64 object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}
